import { Files } from '../../lib/constants/files'
import { Staff } from '../../lib/types/models/staff/staff'
import { StaffInput, StaffUpdateRequest } from '../../lib/types/models/staff/staff-input'
import { NullableTransformer, UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateStaff = async ({
  id: _id,
  criminalRecordStatus: _criminalRecordStatus,
  paySlipStatus: _paySlipStatus,
  idStatus: _idStatus,
  etaStatus: _etaStatus,
  ...data
}: UpdateInput<NullableTransformer<StaffInput>>) => {
  const picture = await uploadFile(Files.STAFF_PROFILE_PICTURE, data.picture)
  const criminalRecord = await uploadFile(Files.STAFF_CRIMINAL_RECORD, data.criminalRecord)
  const identityDocument = await uploadFile(Files.STAFF_IDENTITY_DOCUMENT, data.idFile)
  const eta = await uploadFile(Files.ETA, data.eta)
  const paySlip = await uploadFile(Files.STAFF_PAYSLIP, data.paySlip)
  // Resolve all diploma file uploads
  const diplomas = data.diplomas
    ? await Promise.all(
        data.diplomas.map(async ({ status: _status, ...diploma }) => {
          const file = await uploadFile(Files.STAFF_DIPLOMA, diploma.file)
          return { ...diploma, file }
        })
      )
    : undefined

  const req: NullableTransformer<StaffUpdateRequest> = {
    ...data,
    picture,
    criminalRecord,
    idFile: identityDocument,
    eta,
    paySlip,
    diplomas // Assign resolved diplomas array here
  }
  return restApiClient
    .url(constructApiUrl(API.staffs.update.url, null))
    .patch<Staff, NullableTransformer<StaffUpdateRequest>>(req)
}
